
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/qualifications",
      function () {
        return require("private-next-pages/profile/qualifications.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/qualifications"])
      });
    }
  